import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-16837465"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading-map d-flex justify-content-center align-items-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Espere por favor!!"),
  /*#__PURE__*/_createElementVNode("span", null, "Localizando...")
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  class: "map-container",
  ref: "mapElement"
}
const _hoisted_5 = { id: "menu" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<input id=\"satellite-streets-v12\" type=\"radio\" name=\"rtoggle\" value=\"satellite\" checked=\"checked\" data-v-16837465><label class=\"mx-2\" for=\"satellite-streets-v12\" data-v-16837465>satellite streets</label><input id=\"light-v11\" type=\"radio\" name=\"rtoggle\" value=\"light\" data-v-16837465><label class=\"mx-2\" for=\"light-v11\" data-v-16837465>light</label><input id=\"dark-v11\" type=\"radio\" name=\"rtoggle\" value=\"dark\" data-v-16837465><label class=\"mx-2\" for=\"dark-v11\" data-v-16837465>dark</label><input id=\"streets-v12\" type=\"radio\" name=\"rtoggle\" value=\"streets\" data-v-16837465><label class=\"mx-2\" for=\"streets-v12\" data-v-16837465>streets</label><input id=\"outdoors-v12\" type=\"radio\" name=\"rtoggle\" value=\"outdoors\" data-v-16837465><label class=\"mx-2\" for=\"outdoors-v12\" data-v-16837465>outdoors</label>", 10)
const _hoisted_16 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isUserlocationReady)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_4, null, 512), [
      [_vShow, _ctx.isUserlocationReady]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, _hoisted_16, 512), [
      [_vShow, _ctx.isUserlocationReady]
    ])
  ], 64))
}